import React from "react";

import "./Toast.css";

interface Props {
    text: string;
    type: "info" | "alert";
    buttonText: string;
    onButtonClick: (e: React.MouseEvent) => void;
}

const Toast: React.FC<Props> = function ({ type, text, buttonText, onButtonClick }: Props) {
    return (
        <div className={`toast toast--${type}`}>
            <div className="toast__content">{text}</div>
            <div className="toast__action" onClick={onButtonClick}>
                {buttonText}
            </div>
        </div>
    );
};

export default Toast;
